import { StateSelector } from 'reduxm/modules/selectors'

const mapStateToProps = state => ({
	hierarchicalState: StateSelector.categories.getHierarchical(state),
})

export {
	mapStateToProps,
}
